export const FIELDS = ["firstName", "middleName", "lastName", "id"];
export const INIT = "init";
export const CHANGE = "change";
export const REMOVE = "remove";
